import { Outlet } from "react-router-dom";
import OthersHeader from "./OthersHeader";
// import logo from '../../assets/images/CPRLogo.png';
import logo from '../../assets/images/CPR_LOGO_DARK.png';

const OthersLayout = () => {
    // Define the links for the "Other" pages header
    const navLinks = [
        { label: "Home", href: "/" },
        { label: "Enquire", href: "/#contact" }
    ];
    return (
        <div className="others-layout">
            <OthersHeader logo={logo} links={navLinks} />
            <main style={{ paddingTop: '100px' }}>
                <Outlet />
            </main>
        </div>
    )
}

export default OthersLayout;